import { numberMoney, personName, dateShortWithMonth } from 'Data/format.js'
import { PAYMENT_ACCOUNT_TYPES } from 'Data/constants.js'

export function getAmount(item) {
  return numberMoney(Math.abs(item.amount))
}

export function getPayorName(payment_account) {
  if (!payment_account) return ''

  switch (payment_account.account_type) {
    case PAYMENT_ACCOUNT_TYPES.Person:
      return personName(payment_account.person_payment_account?.payer_person)
    case PAYMENT_ACCOUNT_TYPES.Insurance:
      return payment_account.insurance_payment_account?.insurance_company
        ?.carrier_name
    default:
      return '-'
  }
}

export function getName(payment_plan) {
  let rollback = ''
  if (payment_plan.payment_plan_rollback_id) {
    if (payment_plan.rollback_date) {
      rollback = ` (rolled back on ${dateShortWithMonth(new Date(`${payment_plan.rollback_date}Z`))})`
    } else {
      rollback = ' (rolled back)'
    }
  }

  return `Payment plan${rollback}`
}
